import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import {Provider} from 'react-redux'
import App from './App';
import theme from './theme';
import './styles/styles.css';
import store from "./store";
import GlobalDialog from "./app/global/GlobalDialog";
import Auth from "./app/Auth";
import GlobalToast from "./app/global/GlobalToast";

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline/>
            <Auth>
                <App/>
            </Auth>
            <GlobalDialog/>
            <GlobalToast/>
        </ThemeProvider>,
    </Provider>
);
